import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import Dialog from "vue-dialog-loading";
import { longClickDirective } from "vue-long-click";
import CTextField from "./components/CTextField.vue";

const longClickInstance = longClickDirective({ delay: 2000, interval: 0 });
Vue.directive("longclick", longClickInstance);

Vue.use(Dialog, { dialogBtnColor: "#0f0" });

Vue.config.productionTip = false;
Vue.component("CTextField", CTextField);
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

console.log(`version ${process.env.VUE_APP_VERSION}`);
